import { useEffect } from 'react';

function Crisp() {
  useEffect(() => {
    // const $crisp = window.$crisp;
    // $crisp.push(['do', 'chat:open']);
  }, []);

  return null;
}

export default Crisp;
